export enum SidebarType {
  CONTENT = 'content',
  USER = 'user',
  FINANCE = 'finance',
  OPERATION = 'operation',
  MESSAGE = 'message',
}

export enum FormatLocale {
  /// POSIX
  POSIX,
  /// aa_DJ
  aa_DJ,
  /// aa_ER
  aa_ER,
  /// aa_ER@saaho
  aa_ER_saaho,
  /// aa_ET
  aa_ET,
  /// af_ZA
  af_ZA,
  /// agr_PE
  agr_PE,
  /// ak_GH
  ak_GH,
  /// am_ET
  am_ET,
  /// an_ES
  an_ES,
  /// anp_IN
  anp_IN,
  /// ar_AE
  ar_AE,
  /// ar_BH
  ar_BH,
  /// ar_DZ
  ar_DZ,
  /// ar_EG
  ar_EG,
  /// ar_IN
  ar_IN,
  /// ar_IQ
  ar_IQ,
  /// ar_JO
  ar_JO,
  /// ar_KW
  ar_KW,
  /// ar_LB
  ar_LB,
  /// ar_LY
  ar_LY,
  /// ar_MA
  ar_MA,
  /// ar_OM
  ar_OM,
  /// ar_QA
  ar_QA,
  /// ar_SA
  ar_SA,
  /// ar_SD
  ar_SD,
  /// ar_SS
  ar_SS,
  /// ar_SY
  ar_SY,
  /// ar_TN
  ar_TN,
  /// ar_YE
  ar_YE,
  /// as_IN
  as_IN,
  /// ast_ES
  ast_ES,
  /// ayc_PE
  ayc_PE,
  /// az_AZ
  az_AZ,
  /// az_IR
  az_IR,
  /// be_BY
  be_BY,
  /// be_BY@latin
  be_BY_latin,
  /// bem_ZM
  bem_ZM,
  /// ber_DZ
  ber_DZ,
  /// ber_MA
  ber_MA,
  /// bg_BG
  bg_BG,
  /// bhb_IN
  bhb_IN,
  /// bho_IN
  bho_IN,
  /// bho_NP
  bho_NP,
  /// bi_VU
  bi_VU,
  /// bn_BD
  bn_BD,
  /// bn_IN
  bn_IN,
  /// bo_CN
  bo_CN,
  /// bo_IN
  bo_IN,
  /// br_FR
  br_FR,
  /// br_FR@euro
  br_FR_euro,
  /// brx_IN
  brx_IN,
  /// bs_BA
  bs_BA,
  /// byn_ER
  byn_ER,
  /// ca_AD
  ca_AD,
  /// ca_ES
  ca_ES,
  /// ca_ES@euro
  ca_ES_euro,
  /// ca_ES@valencia
  ca_ES_valencia,
  /// ca_FR
  ca_FR,
  /// ca_IT
  ca_IT,
  /// ce_RU
  ce_RU,
  /// chr_US
  chr_US,
  /// cmn_TW
  cmn_TW,
  /// crh_UA
  crh_UA,
  /// cs_CZ
  cs_CZ,
  /// csb_PL
  csb_PL,
  /// cv_RU
  cv_RU,
  /// cy_GB
  cy_GB,
  /// da_DK
  da_DK,
  /// de_AT
  de_AT,
  /// de_AT@euro
  de_AT_euro,
  /// de_BE
  de_BE,
  /// de_BE@euro
  de_BE_euro,
  /// de_CH
  de_CH,
  /// de_DE
  de_DE,
  /// de_DE@euro
  de_DE_euro,
  /// de_IT
  de_IT,
  /// de_LI
  de_LI,
  /// de_LU
  de_LU,
  /// de_LU@euro
  de_LU_euro,
  /// doi_IN
  doi_IN,
  /// dsb_DE
  dsb_DE,
  /// dv_MV
  dv_MV,
  /// dz_BT
  dz_BT,
  /// el_CY
  el_CY,
  /// el_GR
  el_GR,
  /// el_GR@euro
  el_GR_euro,
  /// en_AG
  en_AG,
  /// en_AU
  en_AU,
  /// en_BW
  en_BW,
  /// en_CA
  en_CA,
  /// en_DK
  en_DK,
  /// en_GB
  en_GB,
  /// en_HK
  en_HK,
  /// en_IE
  en_IE,
  /// en_IE@euro
  en_IE_euro,
  /// en_IL
  en_IL,
  /// en_IN
  en_IN,
  /// en_NG
  en_NG,
  /// en_NZ
  en_NZ,
  /// en_PH
  en_PH,
  /// en_SC
  en_SC,
  /// en_SG
  en_SG,
  /// en_US
  en_US,
  /// en_ZA
  en_ZA,
  /// en_ZM
  en_ZM,
  /// en_ZW
  en_ZW,
  /// eo
  eo,
  /// es_AR
  es_AR,
  /// es_BO
  es_BO,
  /// es_CL
  es_CL,
  /// es_CO
  es_CO,
  /// es_CR
  es_CR,
  /// es_CU
  es_CU,
  /// es_DO
  es_DO,
  /// es_EC
  es_EC,
  /// es_ES
  es_ES,
  /// es_ES@euro
  es_ES_euro,
  /// es_GT
  es_GT,
  /// es_HN
  es_HN,
  /// es_MX
  es_MX,
  /// es_NI
  es_NI,
  /// es_PA
  es_PA,
  /// es_PE
  es_PE,
  /// es_PR
  es_PR,
  /// es_PY
  es_PY,
  /// es_SV
  es_SV,
  /// es_US
  es_US,
  /// es_UY
  es_UY,
  /// es_VE
  es_VE,
  /// et_EE
  et_EE,
  /// eu_ES
  eu_ES,
  /// eu_ES@euro
  eu_ES_euro,
  /// fa_IR
  fa_IR,
  /// ff_SN
  ff_SN,
  /// fi_FI
  fi_FI,
  /// fi_FI@euro
  fi_FI_euro,
  /// fil_PH
  fil_PH,
  /// fo_FO
  fo_FO,
  /// fr_BE
  fr_BE,
  /// fr_BE@euro
  fr_BE_euro,
  /// fr_CA
  fr_CA,
  /// fr_CH
  fr_CH,
  /// fr_FR
  fr_FR,
  /// fr_FR@euro
  fr_FR_euro,
  /// fr_LU
  fr_LU,
  /// fr_LU@euro
  fr_LU_euro,
  /// fur_IT
  fur_IT,
  /// fy_DE
  fy_DE,
  /// fy_NL
  fy_NL,
  /// ga_IE
  ga_IE,
  /// ga_IE@euro
  ga_IE_euro,
  /// gd_GB
  gd_GB,
  /// gez_ER
  gez_ER,
  /// gez_ER@abegede
  gez_ER_abegede,
  /// gez_ET
  gez_ET,
  /// gez_ET@abegede
  gez_ET_abegede,
  /// gl_ES
  gl_ES,
  /// gl_ES@euro
  gl_ES_euro,
  /// gu_IN
  gu_IN,
  /// gv_GB
  gv_GB,
  /// ha_NG
  ha_NG,
  /// hak_TW
  hak_TW,
  /// he_IL
  he_IL,
  /// hi_IN
  hi_IN,
  /// hif_FJ
  hif_FJ,
  /// hne_IN
  hne_IN,
  /// hr_HR
  hr_HR,
  /// hsb_DE
  hsb_DE,
  /// ht_HT
  ht_HT,
  /// hu_HU
  hu_HU,
  /// hy_AM
  hy_AM,
  /// ia_FR
  ia_FR,
  /// id_ID
  id_ID,
  /// ig_NG
  ig_NG,
  /// ik_CA
  ik_CA,
  /// is_IS
  is_IS,
  /// it_CH
  it_CH,
  /// it_IT
  it_IT,
  /// it_IT@euro
  it_IT_euro,
  /// iu_CA
  iu_CA,
  /// ja_JP
  ja_JP,
  /// ka_GE
  ka_GE,
  /// kab_DZ
  kab_DZ,
  /// kk_KZ
  kk_KZ,
  /// kl_GL
  kl_GL,
  /// km_KH
  km_KH,
  /// kn_IN
  kn_IN,
  /// ko_KR
  ko_KR,
  /// kok_IN
  kok_IN,
  /// ks_IN
  ks_IN,
  /// ks_IN@devanagari
  ks_IN_devanagari,
  /// ku_TR
  ku_TR,
  /// kw_GB
  kw_GB,
  /// ky_KG
  ky_KG,
  /// lb_LU
  lb_LU,
  /// lg_UG
  lg_UG,
  /// li_BE
  li_BE,
  /// li_NL
  li_NL,
  /// lij_IT
  lij_IT,
  /// ln_CD
  ln_CD,
  /// lo_LA
  lo_LA,
  /// lt_LT
  lt_LT,
  /// lv_LV
  lv_LV,
  /// lzh_TW
  lzh_TW,
  /// mag_IN
  mag_IN,
  /// mai_IN
  mai_IN,
  /// mai_NP
  mai_NP,
  /// mfe_MU
  mfe_MU,
  /// mg_MG
  mg_MG,
  /// mhr_RU
  mhr_RU,
  /// mi_NZ
  mi_NZ,
  /// miq_NI
  miq_NI,
  /// mjw_IN
  mjw_IN,
  /// mk_MK
  mk_MK,
  /// ml_IN
  ml_IN,
  /// mn_MN
  mn_MN,
  /// mni_IN
  mni_IN,
  /// mnw_MM
  mnw_MM,
  /// mr_IN
  mr_IN,
  /// ms_MY
  ms_MY,
  /// mt_MT
  mt_MT,
  /// my_MM
  my_MM,
  /// nan_TW
  nan_TW,
  /// nan_TW@latin
  nan_TW_latin,
  /// nb_NO
  nb_NO,
  /// nds_DE
  nds_DE,
  /// nds_NL
  nds_NL,
  /// ne_NP
  ne_NP,
  /// nhn_MX
  nhn_MX,
  /// niu_NU
  niu_NU,
  /// niu_NZ
  niu_NZ,
  /// nl_AW
  nl_AW,
  /// nl_BE
  nl_BE,
  /// nl_BE@euro
  nl_BE_euro,
  /// nl_NL
  nl_NL,
  /// nl_NL@euro
  nl_NL_euro,
  /// nn_NO
  nn_NO,
  /// nr_ZA
  nr_ZA,
  /// nso_ZA
  nso_ZA,
  /// oc_FR
  oc_FR,
  /// om_ET
  om_ET,
  /// om_KE
  om_KE,
  /// or_IN
  or_IN,
  /// os_RU
  os_RU,
  /// pa_IN
  pa_IN,
  /// pa_PK
  pa_PK,
  /// pap_AW
  pap_AW,
  /// pap_CW
  pap_CW,
  /// pl_PL
  pl_PL,
  /// ps_AF
  ps_AF,
  /// pt_BR
  pt_BR,
  /// pt_PT
  pt_PT,
  /// pt_PT@euro
  pt_PT_euro,
  /// quz_PE
  quz_PE,
  /// raj_IN
  raj_IN,
  /// ro_RO
  ro_RO,
  /// ru_RU
  ru_RU,
  /// ru_UA
  ru_UA,
  /// rw_RW
  rw_RW,
  /// sa_IN
  sa_IN,
  /// sah_RU
  sah_RU,
  /// sat_IN
  sat_IN,
  /// sc_IT
  sc_IT,
  /// sd_IN
  sd_IN,
  /// sd_IN@devanagari
  sd_IN_devanagari,
  /// se_NO
  se_NO,
  /// sgs_LT
  sgs_LT,
  /// shn_MM
  shn_MM,
  /// shs_CA
  shs_CA,
  /// si_LK
  si_LK,
  /// sid_ET
  sid_ET,
  /// sk_SK
  sk_SK,
  /// sl_SI
  sl_SI,
  /// sm_WS
  sm_WS,
  /// so_DJ
  so_DJ,
  /// so_ET
  so_ET,
  /// so_KE
  so_KE,
  /// so_SO
  so_SO,
  /// sq_AL
  sq_AL,
  /// sq_MK
  sq_MK,
  /// sr_ME
  sr_ME,
  /// sr_RS
  sr_RS,
  /// sr_RS@latin
  sr_RS_latin,
  /// ss_ZA
  ss_ZA,
  /// st_ZA
  st_ZA,
  /// sv_FI
  sv_FI,
  /// sv_FI@euro
  sv_FI_euro,
  /// sv_SE
  sv_SE,
  /// sw_KE
  sw_KE,
  /// sw_TZ
  sw_TZ,
  /// szl_PL
  szl_PL,
  /// ta_IN
  ta_IN,
  /// ta_LK
  ta_LK,
  /// tcy_IN
  tcy_IN,
  /// te_IN
  te_IN,
  /// tg_TJ
  tg_TJ,
  /// th_TH
  th_TH,
  /// the_NP
  the_NP,
  /// ti_ER
  ti_ER,
  /// ti_ET
  ti_ET,
  /// tig_ER
  tig_ER,
  /// tk_TM
  tk_TM,
  /// tl_PH
  tl_PH,
  /// tn_ZA
  tn_ZA,
  /// to_TO
  to_TO,
  /// tpi_PG
  tpi_PG,
  /// tr_CY
  tr_CY,
  /// tr_TR
  tr_TR,
  /// ts_ZA
  ts_ZA,
  /// tt_RU
  tt_RU,
  /// tt_RU@iqtelif
  tt_RU_iqtelif,
  /// ug_CN
  ug_CN,
  /// uk_UA
  uk_UA,
  /// unm_US
  unm_US,
  /// ur_IN
  ur_IN,
  /// ur_PK
  ur_PK,
  /// uz_UZ
  uz_UZ,
  /// uz_UZ@cyrillic
  uz_UZ_cyrillic,
  /// ve_ZA
  ve_ZA,
  /// vi_VN
  vi_VN,
  /// wa_BE
  wa_BE,
  /// wa_BE@euro
  wa_BE_euro,
  /// wae_CH
  wae_CH,
  /// wal_ET
  wal_ET,
  /// wo_SN
  wo_SN,
  /// xh_ZA
  xh_ZA,
  /// yi_US
  yi_US,
  /// yo_NG
  yo_NG,
  /// yue_HK
  yue_HK,
  /// yuw_PG
  yuw_PG,
  /// zh_CN
  zh_CN,
  /// zh_HK
  zh_HK,
  /// zh_SG
  zh_SG,
  /// zh_TW
  zh_TW,
  /// zu_ZA
  zu_ZA,
}
